import MomentUtils from "@date-io/moment";
import {
  CircularProgress,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import CustomPagination from "../Common/CustomPagination";
import EmptyState from "../Common/EmptyState";
import { LuLoader, LuShip } from "react-icons/lu";

import { ThemeProvider, createTheme } from "@material-ui/core/styles";

const compactTheme = createTheme({
  palette: {
    primary: { main: "#313C4C" },
  },
  props: {
    MuiSwitch: { color: "primary" },
  },
  overrides: {
    MuiInputBase: {
      root: { height: 25, fontSize: "11px" },
      input: { padding: "4px 6px !important" },
    },
    MuiOutlinedInput: {
      input: { padding: "4px 6px !important" },
      root: { height: 25 },
    },
    MuiAutocomplete: {
      inputRoot: { padding: "0px !important", minHeight: 25 },
    }
  },
});
function EmailTableContainer(props) {
  const {
    emailParserData = [],
    onSearchByOrgId = () => { },
    selectedEmail = {},
    savePortListByIndex,
    selectedPort,
    delayPortSearch,
    onChangeNewPortValue,
    portLoading,
    onChangeAutoVessel,
    onChangePagination = () => { },
    filters,
    totalPage,
    hasFetched,
  } = props;

  return (
    <ThemeProvider theme={compactTheme}>
      <div className="mui-selected-grey max-h-[280px] overflow-auto scroll-thin">
          <TableContainer component={Paper} className="!rounded-none !shadow-sm auto-add-from-mail">

            {totalPage > filters?.limit && (
              <CustomPagination
                onChangePagination={onChangePagination}
                filters={filters}
                totalPage={totalPage}
              />
            )}

            <Table className="universal-table w-full">
              <TableHead>
                <TableRow>
                  <TableCell>Vessel</TableCell>
                  <TableCell>Dwt</TableCell>
                  <TableCell>Built</TableCell>
                  <TableCell>Position</TableCell>
                  <TableCell>Region</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Gears</TableCell>
                  <TableCell>Sender</TableCell>
                  <TableCell>Updated On</TableCell>
                  <TableCell>Add to Auto Vessel</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {emailParserData.length ? (
                  emailParserData.map((email, index) => {
                    const {
                      _id = "",
                      nearestport = {},
                      nearestDate = {},
                      sender = "",
                      updatedAt = "",
                    } = email;

                    const {
                      vesselName = "",
                      vesselDwt = "",
                      vesselBuilt = "",
                      vesselGears = "",
                    } = email;

                    return (
                      <TableRow
                        key={_id}
                        hover
                        className="h-7 cursor-pointer"
                        selected={selectedEmail._id === _id}
                        onClick={() => onSearchByOrgId(email)}
                      >
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">{vesselName}</TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">{vesselDwt}</TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">{vesselBuilt}</TableCell>

                        {/* ---------------- PORT AUTOCOMPLETE ---------------- */}
                        <TableCell className="!py-1 !px-2 border-r border-gray-300">
                          <Autocomplete
                            options={
                              (savePortListByIndex[index] &&
                                savePortListByIndex[index]) ||
                              []
                            }
                            value={nearestport}
                            getOptionLabel={(option) => option.portLabel}
                            disableClearable
                            onChange={(e, value) =>
                              onChangeNewPortValue(index, value)
                            }
                            className="autocomplete-mui"
                            getOptionSelected={(option, value) =>
                              option.portLabel === value.portLabel
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Search Port"
                                value={nearestport?.portLabel}
                                onChange={(e) =>
                                  delayPortSearch(index, e.target.value)
                                }
                                size="small"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {portLoading[index] ? (
                                        <CircularProgress
                                          color="inherit"
                                          size={15}
                                        />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                          />
                        </TableCell>

                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">{nearestport?.area}</TableCell>

                        {/* ---------------- DATE PICKER ---------------- */}
                        <TableCell className="!py-1 !px-2 border-r border-gray-300">
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DateTimePicker
                              inputVariant="outlined"
                              size="small"
                              format="DD MMM YYYY"
                              className="date-time-picker"
                              style={{ width: 150, height: 32 }}
                              value={moment(nearestDate?.date)}
                              onChange={(date) =>
                                onChangeNewPortValue(index, date, "isDate")
                              }
                            />
                          </MuiPickersUtilsProvider>
                        </TableCell>

                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">{vesselGears}</TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">{sender}</TableCell>
                        <TableCell className="!py-1 !px-2 text-[11px] font-medium border-r border-gray-300">
                          {moment(updatedAt).format("DD MMM YYYY HH:mm:A")}
                        </TableCell>

                        <TableCell className="!py-1 !px-2" onClick={(e) => e.stopPropagation()}>
                          <Switch
                            size="small"
                            checked={email?.showInAutoVessel}
                            onChange={(e) =>
                              onChangeAutoVessel(
                                email?._id,
                                e.target.checked,
                                index
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center" className="!bg-white">
                      {hasFetched ? (
                        <EmptyState
                          icon={LuShip}
                          title="No positions found"
                          text="Try a longer 'Updated since last' range, or clear the Region, Vessel Type and Gears filters, then press Search."
                        />
                      ) : (
                        <EmptyState icon={LuLoader} title="Loading positions..." />
                      )}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
      </div>
    </ThemeProvider>
  );
}

export default EmailTableContainer;
